import { action, observable } from 'mobx';
import axios from 'axios';

import { isTouchDevice } from '../@helpers';
import { Config } from '../config';

class Navigation {
    @observable menu = { 'primary-navigation': [], 'secondary-navigation': [] };
    @observable isTouch = false;

    @action
    populate = async (name) => {
        const endpoint = `${Config.endpoint.wordpress.base}${Config.endpoint.wordpress.lynx}${Config.endpoint.wordpress.navigation}/${name}`;
        const response = await axios.get(endpoint);
        this.menu[name] = response.data;
    }

    @action
    enableTouch = () => {
        this.isTouch = isTouchDevice();
    }

    @action
    toggleNav = (event) => {
        const currentState = event.currentTarget.nextElementSibling.dataset.active
        event.currentTarget.dataset.active = currentState === "false" ? "true" : "false"
        event.currentTarget.nextElementSibling.dataset.active = currentState === "false" ? "true" : "false"
    }

    @action
    isActive = (item, currentUrl) => {
        let activeClass = 'not-active'
        if (item.children) {
            item.children.forEach((child) => {
                if (currentUrl === child.url) {
                    activeClass = 'is-active';
                }
            })
        }

        if (currentUrl === item.url) {
            activeClass = 'is-active'
        }
        return activeClass
    }
}

const NavigationStore = new Navigation();
export default NavigationStore;
